export function getQueryParameters<T>(): T {
    const queryParameters = window.location.search.length > 0 ? window.location.search.replace("?", "").split("&") : [];

    const result = {} as T;
    queryParameters.map((queryParameter) => {
        const queryParameterName = queryParameter.split("=")[0].toLowerCase();
        const queryParameterValue = queryParameter.split("=")[1];

        result[queryParameterName] = queryParameterValue;
    });

    return result;
}

export function setQueryParameters(params: Record<string, any>): string {
    let searchParams = "";
    const paramsKeys = Object.keys(params);
    if (paramsKeys.length === 0) {return "";}
    paramsKeys.forEach((param, index) => {
        searchParams = `${searchParams}${param}=${params[param]}${index === paramsKeys.length - 1 ? "" : "&"}`;
    });
    return `?${searchParams}`;
}


export function setQueryParametersWithoutRefresh (key: string, value: any)  {
    const url = new URL(window.location.href)
    const params = new URLSearchParams(url.search)
    params.set(key, value)
    url.search = params.toString()
    window.history.replaceState(null, "", url.href)
}